// Глобальный in-game toast (Этап 46.20).
// Использование: useToast().show('Текст', 'amber')
// Цвета: 'amber' (оранжевый — лор/предупреждения), 'cyan' (информация),
//        'red' (ошибки), 'green' (успех).
//
// В отличие от window.alert — встроен в стиль игры, не выходит из
// контекста (Telegram WebApp).

import { create } from 'zustand';
import { useEffect } from 'react';
import styles from './Toast.module.css';

type ToastColor = 'amber' | 'cyan' | 'red' | 'green';

interface ToastState {
  text: string | null;
  color: ToastColor;
  show: (text: string, color?: ToastColor, durationMs?: number) => void;
  hide: () => void;
}

let hideTimeout: ReturnType<typeof setTimeout> | null = null;

export const useToast = create<ToastState>((set) => ({
  text: null,
  color: 'amber',
  show: (text, color = 'amber', durationMs = 4500) => {
    set({ text, color });
    if (hideTimeout) clearTimeout(hideTimeout);
    hideTimeout = setTimeout(() => set({ text: null }), durationMs);
  },
  hide: () => {
    if (hideTimeout) clearTimeout(hideTimeout);
    set({ text: null });
  }
}));

// Глобальный компонент-рендерер. Монтируется один раз в App.tsx.
export function ToastHost() {
  const text = useToast(s => s.text);
  const color = useToast(s => s.color);
  const hide = useToast(s => s.hide);

  useEffect(() => {
    if (!text) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') hide(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [text, hide]);

  if (!text) return null;

  return (
    <div className={styles.wrap} onClick={hide}>
      <div className={`${styles.toast} ${styles[color]}`} onClick={(e) => e.stopPropagation()}>
        <span className={styles.text}>{text}</span>
        <button className={styles.close} onClick={hide} aria-label="Закрыть">×</button>
      </div>
    </div>
  );
}
